module.exports = __webpack_public_path__ + "laravelPostit.svg?60cdb74921143efb0ec5d1107f27de29";